module.exports = __webpack_public_path__ + "593a3d53/img/ion_calendar-number.3ac5bd07.svg";